import { Controller, useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';
import { Theme } from '../../Inputs/Radio/Radio.theme';
import { HelperText } from '../../Display';
import {
    useDisabledField,
} from "../HookForm/HookForm.context";

type RadioOption = {
    label: string;
    value: string | number | boolean;
    disabled?: boolean;
};

type RadioGroupProps = {
    name: string;
    options: RadioOption[];
    disabled?: boolean;
    className?: string;
    required?: boolean;
    onChange?: (value: string | number | boolean) => void;
};

const InputRadioGroupSimple: React.FC<RadioGroupProps> = ({
    name,
    options,
    className,
    disabled,
    required,
    onChange
}) => {
    const {
        control,
        formState: { errors }
    } = useFormContext();

    const isDisabled = useDisabledField(name);

    return (
        <div className="relative col-span-2">
            <Controller
                control={control}
                name={name}
                rules={{
                    validate: (value) =>
                        required && ((typeof value === 'string' && value.trim() !== '') || value === true || value === false || 'Field cannot be empty')
                }}
                render={({ field }) => (
                    <div className="flex items-center mb-2">
                        {options.map((option) => (
                            <span key={String(option.value)} className="pr-4 flex items-center">
                                <input
                                    type="radio"
                                    className={twMerge(Theme.input, className)}
                                    value={String(option.value)}
                                    checked={String(field.value) === String(option.value)}
                                    onChange={(e) => {
                                        let parsed: any = e.target.value;
                                        if (parsed === 'true') parsed = true;
                                        else if (parsed === 'false') parsed = false;

                                        field.onChange(parsed);
                                        onChange?.(parsed);
                                    }}
                                    disabled={disabled || option.disabled || isDisabled}
                                />
                                <label className={twMerge(Theme.label, 'min-w-[150px]', disabled && Theme.labelDisabled)}>
                                    {option.label}
                                </label>
                            </span>
                        ))}
                    </div>
                )}
            />
            {errors[name] && (
                <HelperText error={true}>
                    {(errors[name] as any).message ?? 'Field cannot be empty'}
                </HelperText>
            )}
        </div>
    );
};

export default InputRadioGroupSimple;
